import React from 'react'
import {Col, Row} from 'antd'
import PropTypes from 'prop-types'

//Components
import TextField from '../../Common/ViewField'

// Constant
import typo from '../../../constants/dictionaries'
import helper from '../../../helper/helper'
import {RowTableDetail, TableDetail} from "../../Common/View/TableViewDetail";
import constant from '../../../constants/constant'
import DateView from "../../Common/View/DateView";
import TTKT from "../../AttachTable/TTKT/Table";
import Container from "../../../containers/Container";

const TTCdetail = ({data}) => {
  const {
    chucVu,
    coQuanCap,
    ngayBD_HieuLuc,
    ngayKy,
    nguoiKy,
    tenVanBan,
    thoiHan,
    loaiHinhPheDuyet,
    ghiChu,
    ngayQDCu,
    soQDCu,
  } = data || {};
  return (
    <Row>
       <TableDetail>
           
        <RowTableDetail title={typo.cscore_license_type}>{helper.getFieldValueFromID(loaiHinhPheDuyet, constant.LOAI_HINH_PHE_DUYET, "ten")}</RowTableDetail>
        {(loaiHinhPheDuyet == constant.LHPD.PHE_DUYET_MOI || loaiHinhPheDuyet == constant.LHPD.PHE_DUYET_DIEU_CHINH) &&
        <RowTableDetail title={typo.cscore_thoiHanGiayPhep}>{thoiHan}</RowTableDetail>} 

        {loaiHinhPheDuyet != constant.LHPD.PHE_DUYET_MOI &&
        <>
          <RowTableDetail title={typo.cscore_soGiayPhepCu}>{soQDCu}</RowTableDetail>
          <RowTableDetail title={typo.cscore_ngayCapPhepCu}>{helper.formatDate(ngayQDCu)}</RowTableDetail>
        </>}
        <RowTableDetail title={typo.cscore_license_document}>{tenVanBan}</RowTableDetail>
        <RowTableDetail title={typo.cscore_license_agency}>{coQuanCap}</RowTableDetail>
        <RowTableDetail title={typo.cscore_license_signed_person}>{nguoiKy}</RowTableDetail>
        <RowTableDetail title={typo.cscore_license_position}>{chucVu}</RowTableDetail>
        <RowTableDetail title={typo.cscore_license_signed_date}>{helper.formatDate(ngayKy)}</RowTableDetail>
        <RowTableDetail title={typo.cscore_license_available_date}>{helper.formatDate(ngayBD_HieuLuc)}</RowTableDetail>
        <RowTableDetail title={typo.cscore_ghiChu}>{ghiChu}</RowTableDetail>
        {/*<RowTableDetail title={typo.cscore_license_place_received}>{noiNhan}</RowTableDetail>*/}
      </TableDetail>
    </Row>
  )
};

TTCdetail.propTypes = {
  data: PropTypes.any.isRequired,
};

export default TTCdetail
